<template>
  <div>
    <!-- 兑换标题 -->
    <div class="groud-title">
      <span class="title-text">{{ $t(title) }}</span>
      <div class="title-more" @click="goToMore" v-if="groups.length > 3">
        <span>{{ $t('更多') }}</span>
        <img src="@/assets/images/icon_back_rigth.webp" alt="" />
      </div>
    </div>
    <!-- 兑换列表 -->
    <div class="groud-content">
      <div class="parts">
        <div
          v-for="(value, index) in groups.slice(0,3)"
          :key="index"
          :class="[
            'part-item',
            (value.useing || value.chatUseing || value.liveSkinUseing) && 'part-item-useing'
          ]"
          @click="handleShowPart(value)"
          :data-text="$t('使用中')"
        >
          <div class="part-item-pic">
            <div
              class="part-item-pic-svg"
              :id="`part-item-pic-svg-${type + '' + index}`"
              v-if="!('sku' in value) || value.type == 1"
            >
            <!-- 判断是否是皮肤资料卡 -->
              {{ getImageAdapter(value.useType !== 3 ? value.url : value.motionUrl, `#part-item-pic-svg-${type + '' + index}`) }}
            </div>
            <div class="part-item-pic-svg" v-else>
              <Pendant :url="value.motionUrl" />
            </div>
          </div>
          <div class="part-item-title text-ellipsis">
            {{ language == 'ug' ? value.nameUig : value.name }}
          </div>
          <div
            :class="[
              'part-item-pric',
              language === 'ug' && 'part-item-pric-ug'
            ]"
            v-html="resultPriceFixIcon(value)"
          >
          </div>
        </div>
      </div>
    </div>
    <!-- 兑换弹窗 -->
    <!-- <ConvertDialog :isShow.sync="isShow" :partInfo="partInfo" /> -->
  </div>
</template>

<script>
import { imageAdapter } from '@/utils/index'
import { CommonModule } from '@/store/modules/common'
import Pendant from '@/components/Pendant.vue'
// import ConvertDialog from './ConvertDialog.vue'

export default {
  name: 'SkinCard',
  components: {
    Pendant,
    // ConvertDialog
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    groups: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    resultPriceFixIcon() {
      const icon_resource = {
        diamond: require('@/assets/gameCoin/diamond.webp'),
        gameCoin: require('@/assets/gameCoin/game-coin-icon.png'),
        goldCoin: require('@/assets/images/gold_coin_icon.webp')
      }
      return value => {
        let img_resource = icon_resource.diamond
        let currencyCode = null
        let price = ''
        // 装扮
        if ('sku' in value) {
          if(!(value.payType == 2 && value.sku[0])) return `<span>${this.$t('非卖品')}</span>`
          currencyCode = value.sku[0].currencyCode
          price = value.sku[0].currentPrice
        } else {
          // 权益
          currencyCode = value.currencyCode
          price = value.gameCoin
        }
        if (currencyCode == 1) img_resource = icon_resource.diamond
        else if (currencyCode == 3) img_resource = icon_resource.gameCoin
        else if (currencyCode == 4) img_resource = icon_resource.goldCoin
        return img_resource ? `<img style="width: 16px; height: 16px; margin-left: 2px" src="${img_resource}" alt="" /><span style="padding: 0 2px;font-size: 12px;">${price}</span>` : ''
      }
    }
  },
  data() {
    return {
      // isShow: false,
      // partInfo: {},
      language: CommonModule.language
    }
  },
  methods: {
    goToMore() {
      this.$router.push({
        path: 'moreConvert',
        query: {
          type: this.type,
          title: this.title,
          language: this.language,
          statusBarHeight: this.$route.query.statusBarHeight || 0
        }
      })
    },
    getImageAdapter(url, container, className) {
      imageAdapter(url, container, className, this.$nextTick)
    },
    handleShowPart(value) {
      // 装扮非卖品不弹窗
      if ('sku' in value && !(value.sku && value.sku.length && value.payType === 2)) return
      // 权益非卖品不弹窗
      if (!('sku' in value) && !value.gameCoin) return
      // this.isShow = true
      // this.partInfo = value
      this.$emit('handleShowPart', { partInfo: value })
    }
  }
}
</script>

<style lang="scss" scoped>
.groud-title {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  .title-text {
    position: relative;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    &::after {
      content: '';
      position: absolute;
      right: -15px;
      top: -12px;
      width: 44px;
      height: 38px;
      background: url('../../../assets/images/shop-tilte-icon.png') no-repeat;
      background-size: cover;
    }
  }
  .title-more {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #999999;
    img {
      width: 18px !important;
      height: 18px !important;
    }
  }
}
.parts {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  place-items: center;

  .part-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 107px;
    height: 131px;
    background: #32296a;
    border-radius: 12px;
    border: 1px solid #232733;
    box-sizing: border-box;
    padding: 0 3px;

    .part-item-pic {
      .part-item-pic-svg {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
      }
    }

    .part-item-title {
      width: 100%;
      font-weight: 400;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      padding: 8px 0 6px 0;
    }

    .part-item-pric {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 10px;
      color: #9994b5;
    }

    .part-item-pric-ug {
      font-size: 9px;
      font-family: 'UKIJCJK';
    }
  }

  .part-item-active {
    background: rgba(185, 117, 255, 0.2);
    border: 1px solid #b975ff;
  }

  .part-item-useing {
    &::after {
      content: attr(data-text);
      position: absolute;
      top: -8px;
      left: 0;
      font-size: 10px;
      color: #ffffff;
      padding: 3px 8px;
      background-color: #fa5051;
      border-radius: 9px 9px 9px 0;
    }
  }
}
</style>
